<template>
    <div class="field">
        <label v-if="label" class="label">
            {{ label }}{{ hideLabelColon ? '' : ':' }}
            <span>&nbsp;</span>
            <fa-icon
                v-if="tooltip"
                v-tooltip="tooltipInfo"
                icon="info-circle"
                class="configurationProfile__tooltip-icon"
            />
        </label>
        <label v-if="subLabel" class="sub-label">
            {{ subLabel }}
        </label>
        <p class="control" :class="controlClass">
            <textarea
                v-model="value"
                :id="theId"
                ref="textarea"
                class="textarea"
                :maxlength="maxlength"
                :value="value"
                :placeholder="placeholder"
                :class="inputClass"
                :rows="rows"
                :disabled="disabled"
                :readonly="readonly"
                @input="updateValue($event.target.value)"
                @click="$emit('click', $event)"
            />
        </p>
        <p v-if="error" class="help has-text-danger" v-text="error" />
    </div>
</template>

<script>

export default {
    emits: ['input', 'click', 'update:modelValue'],

    props: {
        modelValue: { default: '' },
        label: { type: String, default: '' },
        subLabel: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        rows: { type: Number, default: 5 },
        maxlength: { type: Number, default: 524288 },
        resize: { type: Boolean, default: false },
        focus: { type: Boolean, default: false },
        error: { type: String, default: '' },
        id: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        tooltip: { type: [String, Object], default: '' },
        hideLabelColon: { type: Boolean, default: false },
    },

    data() {
      return {
          value: this.modelValue
      }
    },

    computed: {
        tooltipInfo() {
            if (typeof this.tooltip === 'object') {
                return {
                    placement: 'top',
                    ...this.tooltip,
                };
            }

            return {
                content: this.tooltip,
                placement: 'top',
            };
        },

        controlClass() {
            let classes = [];

            if (this.icon) {
                classes.push('has-icons-left');
            }

            if (this.error) {
                classes.push('has-icons-right');
            }

            return classes.join(' ');
        },

        inputClass() {
            let classes = [];

            if (this.$attrs.class) {
                classes = this.$attrs.class.split(' ');
            }

            if (this.error) {
                classes.push('is-danger');
            }

            if (!this.resize) {
                classes.push('is-no-resize');
            }

            return classes.join(' ');
        },

        theId() {
            return this.id ? this.id : `form-textarea-${Math.random().toString(36).substr(2, 9)}`;
        },
    },

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            this.$emit('update:modelValue', value);
        },
    },

    mounted() {
        if (this.focus) {
            this.$refs.textarea.focus();
        }
    },
};
</script>
